<template>
  <div>
    <h1 class="h3 mb-3 text-gray-800">
      {{ $t("Detalhes do Encaminhamento") }}
    </h1>

    <loading-animation
      :active.sync="loading"
      :is-full-page="false"
      :opacity="1"
      color="#5895FF"
    />
    <div class="row">
      <div class="col-md-12">
        <print-content>
          <table
            class="table b-table b-table-stacked-md table-bordered table-sm bg-white"
          >
            <tbody>
              <tr>
                <td>
                  ID: <strong>{{ item.id }}</strong>
                </td>
                <td>
                  PROTOCOLO: <strong>{{ item.protocolo }}</strong>
                </td>
                <td>
                  CADASTRADO:
                  <strong>{{ item.cadastrado }}</strong>
                </td>
                <td>
                  ATUALIZADO:
                  <strong>{{ item.atualizado }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  USUÁRIO(S) ATENDIDO(S):
                  <strong
                    class="mr-2"
                    v-for="(pessoa, index) in pessoas"
                    :key="pessoa.id"
                  >
                    {{ pessoa.nome_completo || pessoa.nome_acolhido }}
                    <span v-if="index < pessoas.length - 1">,</span>
                  </strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  TÉCNICO RESPONSÁVEL: <b v-if="item.responsavel">{{
                    item.responsavel.nome
                  }}</b>
                </td>
                <td>
                  TÉCNICO AUTOR:
                  <b>{{ item.autor }}</b>
                </td>
                <td>
                  UNIDADE DE ORIGEM:
                  <b v-if="item.unidade">{{ item.unidade.nome }}</b>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  DESTINATÁRIO:<b v-if="item.destino">{{ item.destino.nome }}</b>
                </td>
                <td colspan="2">
                  UNIDADE DE DESTINO:
                  <b v-if="item.unidade_destino">{{ item.unidade_destino.nome }}</b>
                  <span v-if="item.unidade_externa" class="text-muted text-xs">
                    - Unidade Externa
                  </span>
                </td>
              </tr>
              <tr class="table-secondary">
                  <td colspan="4">
                      Tipo de
                      Encaminhamento:
                      <b>{{
                          item.tipo
                      }}</b>
                  </td>
              </tr>
              <tr v-if="item.data_prevista != ''">
                <td colspan="3">
                  DATA E HORA DO AGENDAMENTO (Se houver)
                  <b>{{ item.data_prevista | formatDate() }}</b>
                  <b>{{ item.hora_prevista | formatHora() }}</b>
                </td>
                <td>
                  STATUS:
                  <strong
                    v-html="
                      verificarValueArray(item.status, $root.arrays.encaminhamento_status)
                    "
                  ></strong>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  OBSERVAÇÃO:
                  <div v-html="item.descricao"></div>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Área de Solicitações de Agendamentos -->
          <div
            class="col-md-12"
            v-if="item.agendamentos && item.agendamentos.length > 0"
            id="agendamentos"
          >
            <Agendamentos
              :agendamentos="item.agendamentos"
              @voltar="solicitacoesAgendamentos = false"
              @reload="getItem(), (solicitacoesAgendamentos = true)"
            />
          </div>
          <!-- Área de Solicitações de Agendamentos -->

          <anexos :anexos="item.anexos" />

          <HistoricoStatus
            v-if="item.id"
            :id="item.id"
            :familia="item.familia_id"
            :status="status_item"
            :resposta="true"
          />

          <print-footer 
            v-if="item.responsavel && item.responsavel.assinatura_digital" 
            :tecnico="item.responsavel" 
            class="mt-0" 
            :assinatura="item.responsavel.assinatura_digital"
            :wpp="wpp"
            :email="email"
          />
             
          <p class="text-muted">{{ app_cidade }}, {{ app_data_atual }}</p>

          <div class="row pt-4 px-0 d-flex justify-content-end no-print area-botoes-show">
            <div class="col-auto px-2 text-right">

              <form-toggle
                grid="12"
                mt="0"
                v-model="email"
                label="Email"
              />
              <form-toggle
                grid="12"
                mt="0"
                v-model="wpp"
                label="Telefone/WhatsApp"
              />

              <a class="btn btn-default" @click="$router.go(-1)">
                <i class="mdi mdi-arrow-left" />
              </a>

              <a
                class="btn btn-secondary"
                @click.prevent="$bvModal.show('cadastrar-resposta-encaminhamento')"
                v-if="
                  (item.respondido != 'RESPONDIDO' &&
                    item.unidade_destino_id == unidade_id) ||
                  item.user_destino_id == user_id
                "
              >
                <i class="mdi mdi-reply"></i> Responder
              </a>

              <a class="btn btn-primary" @click="print()">
                <i class="mdi mdi-printer" />
              </a>
            </div>
          </div>
        </print-content>
      </div>
    </div>
    <ModalResposta :item="item" @submit="submit" />
  </div>
</template>
<script>
import HistoricoStatus from "./HistoricoStatus";
import ModalResposta from "./includes/ModalResposta";
import Agendamentos from "./includes/SolictacoesAgendamento";
export default {
  components: {
    ModalResposta,
    Agendamentos,
    HistoricoStatus,
  },
  name: "Show",
  data() {
    return {
      loading: true,
      item: {
        anexos: [],
        pessoas_objetos: [],
        pessoas_acolhimento: []
      },
      app_cidade: this.$store.state.settings.app_cidade,
      app_data_atual: this.$store.state.settings.app_data_atual,
      servicos: [],
      unidades: [],
      status_item: [],
      user_id: null,
      unidade_id: null,
      email: true,
      wpp: true
    };
  },
  mounted() {
    this.getUnidades();
    this.getStatusFinais();
    this.getServicos();
    this.getItem();
  },
  computed: {
    pessoas() {
      // Se pessoas_objetos estiver vazio ou contiver apenas null
      if (
        !this.item.pessoas_objetos ||
        this.item.pessoas_objetos.length === 0 ||
        this.item.pessoas_objetos.every(p => p === null)
      ) {
        return this.item.pessoas_acolhimento || [];
      }
      return this.item.pessoas_objetos;
    },
  },
  methods: {
    getItem() {
      this.loading = true;
      axios
        .get(`api/dashboard/encaminhamentos/${this.$route.params.id}`)
        .then((response) => {
          this.item = response.data.data;
          this.unidade_id = this.$store.state.user.unidade.id;
          this.user_id = this.$store.state.user.tecnico.id;
          this.loading = false;
        })
        .catch((error) => {
          this.$router.push("/dashboard/encaminhamentos/");
        });
    },
    getStatusFinais() {
      axios
        .post(`api/dashboard/get/status/finais`, {
          model: "Encaminhamento",
          module: "Encaminhamento",
        })
        .then((response) => {
          this.status_item = response.data;
        });
    },
    getServicos() {
      axios.get(`api/dashboard/atendimento/servicos`).then((response) => {
        this.servicos = response.data;
      });
    },
    getUnidades() {
      axios.get(`api/dashboard/unidades/get/externas/PLANTAO`).then((response) => {
        this.unidades = response.data;
      });
    },
    verificarValueArray(value, array) {
      const result = array.filter((item) => item.id == value);
      return result[0] ? result[0].value : "";
    },
    print() {
      const modal = document.getElementById("boxPrint");
      const cloned = modal.cloneNode(true);
      let section = document.getElementById("print");

      if (!section) {
        section = document.createElement("div");
        section.id = "print";
        document.body.appendChild(section);
      }

      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();
    },
    submit() {
      var item = {
        id: this.item.id,
        status: 2,
        user_destino_id: this.$store.state.user.tecnico.id,
      };
      axios.post(`api/dashboard/update/encaminhamento`, item).then((response) => {
        this.$snack.success({
          button: false,
          text: response.data.data.message,
        });
        this.getItem();
        this.$bvModal.hide("cadastrar-resposta-encaminhamento");
      });
    },
  },
};
</script>

<style>

.area-botoes-show {
  padding-bottom: 90px;
}

@media screen {
  #print {
    display: none;
  }
}

@media print {
  body * {
    visibility: hidden;
  }
  #print,
  #print * {
    visibility: visible;
  }
  #print {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
